import axios from "axios";
import settings from "../settings";
import router from "@/router";

let newCampaignData = {
    is_new: true,
    name: null,
    description: null,
    info_provider: "eugesta",
    start_date: null,
    end_date: null,
    products: [],
    percent: 0,
    client_id: null,
    export_client_id: null,
    store_id: null,
    tag_id: null
};

const infoProviders = ["eugesta", "smarten", "odoo"];

let initialState = {
    loadingCampaignList: false,
    loadingCampaignData: false,
    requestSuccess: false,
    requestError: false,
    drawerOpen: false,
    activeCampaign: {},
    campaigns: [],
    searchCampaignString: "",
    infoProviders: infoProviders,
    errorMessage: "",
    campaignsCount: 0
};

export default {
    namespaced: true,
    state: { ...initialState },
    actions: {
        async getCampaignList({ commit }, search = null) {
            await commit("setCampaignListLoading", true);
            try {
                let response = await axios.get(settings.api_url + "/campaigns", { params: search });
                if (response?.data?.success === 1) {
                    let data = response.data;
                    await commit("addCampaigns", data.campaigns);
                    await commit("addCampaignsTotalCount", data.total_campaigns_count);
                }
            } catch (e) {
                console.log(e);
            }
            await commit("setCampaignListLoading", false);
        },
        async getCampaignData({ commit }, campaignId) {
            commit("setCampaignDataLoading", true);
            try {
                let response = await axios.get(settings.api_url + "/campaign/" + campaignId);
                if (response.data?.success === 1) {
                    let data = response.data;
                    commit("setActiveCampaign", data.campaign_data);
                }
            } catch (e) {
                console.log(e);
            }
            commit("setCampaignDataLoading", false);
        },
        async submitCampaignUpdate({ commit, dispatch }, payload) {
            await commit("setRequestSuccess", false);
            await commit("setErrorMessage", "");
            await commit("setCampaignDataLoading", true);
            try {
                let response = await axios.post(settings.api_url + "/campaign/", payload);
                if (response.status === 200 && response.data.success === 1) {
                    await dispatch("getCampaignList");
                    await commit("setRequestSuccess", true);
                }
            } catch (e) {
                console.log(e);
            }
            await commit("setCampaignDataLoading", false);
        },
        async deleteCampaign({ commit, dispatch }, { campaignId }) {
            await commit("setRequestSuccess", false);
            await commit("setErrorMessage", "");
            await commit("setCampaignListLoading", true);
            try {
                let response = await axios.delete(settings.api_url + "/campaign/", {
                    params: { campaign_id: campaignId }
                });
                if (response && response.data.success === 1) {
                    await dispatch("getCampaignList");
                    await commit("setRequestSuccess", true);
                } else if (response.data.success === 0) {
                    await commit("setRequestError", true);
                    await commit("setErrorMessage", "Failed");
                }
            } catch (e) {
                console.log(e);
                commit("setRequestError", true);
                commit("setErrorMessage", "Failed");
            }
            commit("setCampaignListLoading", false);
            router.push("/campaigns");
        },
        async deleteCampaignProduct({ commit, dispatch }, { campaignId, productId }) {
            try {
                let response = await axios.delete(settings.api_url + "/campaign-product/", {
                    params: { campaign_id: campaignId, product_id: productId }
                });
                if (response && response.data.success === 1) {
                    await dispatch("getCampaignData", campaignId);
                } else if (response.data.success === 0) {
                    console.log("success: 0");
                }
            } catch (e) {
                console.log(e);
            }
        }
    },
    mutations: {
        setRequestSuccess(state, bool) {
            state.requestSuccess = bool;
        },
        setRequestError(state, bool) {
            state.requestError = bool;
        },
        setErrorMessage(state, message) {
            state.errorMessage = message;
        },
        addCampaigns(state, campaigns) {
            state.campaigns = campaigns;
        },
        addCampaignsTotalCount(state, count) {
            state.campaignsCount = count;
        },
        setActiveCampaign(state, campaign) {
            state.activeCampaign = { ...campaign };
        },
        toggleDrawer(state, isOpen) {
            state.drawerOpen = isOpen;
        },
        resetActiveCampaign(state) {
            state.activeCampaign = {};
        },
        addNewCampaign(state) {
            state.activeCampaign = { ...newCampaignData };
        },
        updateActiveCampaignProperty(state, { prop, value }) {
            state.activeCampaign = {
                ...state.activeCampaign,
                [prop]: value
            };
        },
        updateCampaignSearch(state, payload) {
            state.searchCampaignString = payload.term;
            this.dispatch("CampaignStore/getCampaignList", {
                search: state.searchCampaignString
            });
        },
        resetCampaignSearch(state) {
            state.searchCampaignString = "";
        },
        setCampaignListLoading(state, value) {
            state.loadingCampaignList = value;
        },
        setCampaignDataLoading(state, value) {
            state.loadingCampaignData = value;
        },
        removeCampaignProduct(state, value) {
            state.activeCampaign.products.splice(value, 1);
        }
    }
};
